// AI Generated
import { Component, OnInit, Optional, Inject } from '@angular/core';
import { LoginService } from '@client/app/core/services/login/login.service';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { StateService } from '@uirouter/core';
import { IS_MICROFRONTEND } from '@client/mfe/tokens/mfe-tokens';

@Component({
    selector: 'login',
    template: ``,
    standalone: false,
})
export class LoginComponent implements OnInit {

    constructor (
        private loginService: LoginService,
        private stateService: StateService,
        private uiRouterTransitionService: MonUIRouterTransitionService,
        @Optional() @Inject(IS_MICROFRONTEND) private readonly isMicrofrontend: boolean | null,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        if (this.loginService.isLoggedIn()) {
            this.uiRouterTransitionService.onTransitionFinished(
                () => {
                    this.stateService.go('base.dashboard');
                },
            );
            return;
        }
        if (this.isMicrofrontend) {
            return;
        }
        window.location.href = this.loginService.getAuthorizeUrl();
    }
}
